/* Visualization-project upload helper.
 *
 * Self-contained: no Drive, no LAS/LAZ allowlist, no `googleDriveId` field,
 * no shared imports from uploadStrategies.js. Posts a single multipart-form
 * request to /api/projects/<id>/upload/visualization, which writes the file
 * to the project's dedicated S3 bucket and inserts a row (with s3_key) into
 * the per-project storage table.
 *
 * Do NOT add branches here for rsa-existing / rsa-model — they get their
 * own helpers. Cross-type branching is the bug class this split exists to
 * prevent.
 */

export async function uploadVisualizationFile({
  file,
  parentId,
  onProgress,
  registerXhr,
  unregisterXhr,
  api,
}) {
  const url = `${api.apiBaseUrl}/api/projects/${api.projectId}/upload/visualization`;
  const form = new FormData();
  form.append('file', file);
  form.append('parent_id', String(parentId));

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    if (registerXhr) registerXhr(xhr);

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress({ loadedBytes: e.loaded, totalBytes: e.total || file.size });
      }
    });

    xhr.onload = () => {
      if (unregisterXhr) unregisterXhr(xhr);
      let payload = null;
      try { payload = JSON.parse(xhr.responseText); } catch (_e) { /* keep null */ }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(payload || { success: true });
      } else {
        const msg = (payload && payload.error)
          || `Visualization upload failed (${xhr.status})`;
        reject(new Error(msg));
      }
    };

    xhr.onerror = () => {
      if (unregisterXhr) unregisterXhr(xhr);
      reject(new Error('Network error during visualization upload'));
    };

    xhr.onabort = () => {
      if (unregisterXhr) unregisterXhr(xhr);
      reject(new Error('Upload cancelled'));
    };

    xhr.open('POST', url);
    xhr.withCredentials = true;
    if (api.authToken) {
      xhr.setRequestHeader('Authorization', `Bearer ${api.authToken}`);
    }
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send(form);
  });
}
